import styled from "styled-components";

export const ResultGroup = styled.div`
  margin-bottom: 32px;
`;

export const ResultGroupTitle = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: var(--primary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--gray-light);
`;

export const ResultItem = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  background: var(--lightest);
  border: 1px solid var(--gray-light);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--primary);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
`;

export const ResultItemTitle = styled.span`
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: var(--neutral);
`;

export const ResultItemSubtitle = styled.span`
  display: block;
  font-size: 0.875rem;
  color: var(--neutral-light);
  margin-top: 4px;

  mark {
    background: #fff3a3;
    color: inherit;
    border-radius: 2px;
    padding: 0 2px;
  }
`;

export const ModuleShortcutCard = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-align: left;
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-light) 100%);
  color: var(--lightest);
  border: none;
  border-radius: 10px;
  padding: 20px 24px;
  margin-bottom: 24px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  span.arrow {
    font-size: 1.25rem;
  }
`;
